import { render, staticRenderFns } from "./RibbonTitle.vue?vue&type=template&id=7160380d&"
import script from "./RibbonTitle.vue?vue&type=script&lang=js&"
export * from "./RibbonTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports